import React, { useState, useRef } from 'react';
import { Svg, Text, TextLink } from '@mlc/web-ui-toolkit';
import { download } from '@mlc/symbols';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import {
	showError,
	showSuccess,
} from '../../../../../events/NotificationEmitter';
import { downloadCsv, Options } from '../../../../common/csvDownloader';
import planProfileTestIds from '../PlanProfile.elements';

export interface DownloadCsvProps {
	label?: string;
	icon?: IconDefinition;
	options: Options;
	fetchDataToDownload: Function;
}

const DownloadCsv: React.FunctionComponent<DownloadCsvProps> = ({
	label,
	options,
	fetchDataToDownload,
}: DownloadCsvProps) => {
	const [loading, setLoading] = useState(false);
	const actionButtonRef = useRef<any>();
	const focus = () => {
		if (actionButtonRef.current) {
			actionButtonRef.current.focus();
		}
	};

	const handleOnClick = async () => {
		setLoading(true);
		try {
			const data = await fetchDataToDownload();
			downloadCsv(data, options);
			setLoading(false);
			showSuccess('File downloaded', focus);
		} catch (e) {
			showError(`Something went wrong. We couldn't download your file.`, focus);
			setLoading(false);
		}
	};

	return (
		<TextLink
			onClick={!loading ? handleOnClick : undefined}
			el="button"
			ref={actionButtonRef}
			style={{
				display: 'flex',
			}}
		>
			{!loading ? (
				<Svg
					symbol={download}
					marginRight={2}
					marginTop={1}
					color="mlcOrange"
				/>
			) : null}
			<Text color="mlcOrange" data-id={planProfileTestIds.downloadCsv}>
				{loading ? 'Downloading...' : label ? label : 'Download CSV'}
			</Text>
		</TextLink>
	);
};

export default DownloadCsv;
